import React from 'react';
import { Grid, Typography, createStyles, makeStyles } from '@material-ui/core';
import { useTranslation } from '../../../../hooks/useTranslation';
import Modal from '../../../modal';
import Button from '../../../buttons';
import colors from '../../../../themes/main-colors';
import theme from '../../../../themes/theme';

type RegistrationFailedModalProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontSize: '32px',
      color: colors.noirBlur,
      marginBottom: '6px',
    },
    container: {
      maxWidth: '680px',
    },
    body: {
      backgroundColor: colors.modalBackgroundColor,
      marginTop: '20px',
      padding: '10px 25px 10px 25px',
      borderRadius: '4px',
      boxShadow: `0px 3px 6px ${colors.boxShadowColor}`,
    },
    bodyText: {
      fontSize: '18px',
      color: colors.noirBlur,
      marginTop: '10px',
    },
    marginBottom: {
      marginBottom: '6px',
    },
    actions: {
      display: 'flex',
      justifyContent: 'end',
      marginTop: '20px',
    },
    okay: {
      fontSize: '18px',
      color: colors.white,
      padding: '5px 25px 5px 25px',
      marginLeft: '20px',
      [theme.breakpoints.down('sm')]: {
        width: '45%',
        marginLeft: '10px',
      },
    },
  }),
);

export const RegistrationFailedModal = (
  props: RegistrationFailedModalProps,
) => {
  const { isOpen, handleClose } = props;
  const { t, inlineRichT } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      open={isOpen}
      showCloseIcon={true}
      onClose={handleClose}
      title={
        <Typography variant="body1" className={classes.title}>
          {''}
        </Typography>
      }
    >
      <Grid container className={classes.container}>
        <Grid container className={classes.body}>
          <Typography
            className={`${classes.bodyText} ${classes.marginBottom}`}
            data-testid="modal-body-text"
          >
            {inlineRichT('YOUR_START_SERVICE_WAS_SUCCESSFUL', {
              PGE_PHONE: t('PGE_PHONE'),
            })}
          </Typography>
        </Grid>
        <Grid container className={classes.actions}>
          <Button
            color={'primary'}
            variant={'contained'}
            className={classes.okay}
            onClick={handleClose}
            data-testid="modal-okay-button"
          >
            {t('OK')}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};
